import src from "IMAGE";
export default { src, width: 341, height: 48, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AD4XfnFFGYx9OxZ4bDAVYGYVFiB5ERUYchEUGG8RFBhujmsHtxStqiIAAAAASUVORK5CYII="};
